/**
 * PURPOSE: Centralizar columnas permitidas de la matriz de uniformes.
 * RESPONSIBILITIES: Resolver catálogo por deporte y etiquetas de tipo/tono.
 * COLLABORATORS: UniformMatrix.jsx y UniformMatrixColumnPicker.jsx.
 * ROUTE: winscore/src/components/UniformMatrix/uniformMatrix.constants.js
 */
export const UNIFORM_TYPES = {
  JERSEY: 1,
  GOALKEEPER: 2,
  LIBERO: 3,
};
export const UNIFORM_TONES = { LIGHT: 1, DARK: 2 };

const FOOTBALL_IDS = new Set([5, 42, 52, 53, 117, 118, 119, 120, 121, 122]);
const FUTSAL_IDS = new Set([6, 7, 109, 110]);
const VOLLEYBALL_IDS = new Set([16, 17, 54, 55, 100, 101, 102, 103, 104, 113, 114, 115, 116, 999]);
const BEACH_VOLLEYBALL_IDS = new Set([44, 45]);

export const BASE_COLUMNS = [
  { type: 1, tone: 1, label: "Camiseta clara" },
  { type: 1, tone: 2, label: "Camiseta oscura" },
];

export const getUniformColumnCatalog = (idsport) => {
  const id = Number(idsport);
  const result = [...BASE_COLUMNS];
  if (FOOTBALL_IDS.has(id) || FUTSAL_IDS.has(id)) {
    result.push(
      { type: 2, tone: 1, label: "Arquero claro" },
      { type: 2, tone: 2, label: "Arquero oscuro" },
    );
  }
  if (VOLLEYBALL_IDS.has(id) && !BEACH_VOLLEYBALL_IDS.has(id)) {
    result.push(
      { type: 3, tone: 1, label: "Líbero claro" },
      { type: 3, tone: 2, label: "Líbero oscuro" },
    );
  }
  return result;
};

export const uniformCellKey = ({ idparticipant, type, tone, slotNo }) =>
  `${Number(idparticipant)}:${Number(type)}:${Number(tone)}:${Number(slotNo)}`;

export const uniformColumnKey = ({ type, tone, slotNo }) =>
  `${Number(type)}:${Number(tone)}:${Number(slotNo)}`;
